/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * The version of the OpenAPI document: Latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  LabelValuePair,
  LabelValuePairFromJSON,
  LabelValuePairFromJSONTyped,
  LabelValuePairToJSON,
  Operator,
  OperatorFromJSON,
  OperatorFromJSONTyped,
  OperatorToJSON,
  Package,
  PackageFromJSON,
  PackageFromJSONTyped,
  PackageToJSON,
} from "./";

/**
 *
 * @export
 * @interface Metadata
 */
export interface Metadata {
  /**
   *
   * @type {Array<Operator>}
   * @memberof Metadata
   */
  operators: Array<Operator>;
  /**
   *
   * @type {Array<Package>}
   * @memberof Metadata
   */
  packages: Array<Package>;
  /**
   *
   * @type {Array<LabelValuePair>}
   * @memberof Metadata
   */
  targetGroups: Array<LabelValuePair>;
}

export function MetadataFromJSON(json: any): Metadata {
  return MetadataFromJSONTyped(json, false);
}

export function MetadataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Metadata {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    operators: (json["operators"] as Array<any>).map(OperatorFromJSON),
    packages: (json["packages"] as Array<any>).map(PackageFromJSON),
    targetGroups: (json["targetGroups"] as Array<any>).map(
      LabelValuePairFromJSON,
    ),
  };
}

export function MetadataToJSON(value?: Metadata | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    operators: (value.operators as Array<any>).map(OperatorToJSON),
    packages: (value.packages as Array<any>).map(PackageToJSON),
    targetGroups: (value.targetGroups as Array<any>).map(LabelValuePairToJSON),
  };
}
